import React, { useEffect, useState } from 'react';

import DirectionsResultControlsViewMulti from './DirectionsResultControlsViewMulti.tsx';

const DirectionsResultControls = ({
  onBackFromNavigationClicked,
  onBackButtonClicked,
  onSwitchDirectionsButtonClicked,
  onSwitchRouteTypeButtonClicked,
  onInputClearButtonClick,
  handleChange,
  widgetState,
  handleInputSelect,
  isBackButtonDisabled,
  isDesktop,
  logoUrl,
  clientName,
  handleSearchInputsChange,
  handleAddStopSelect,
  T,
  ...rest
}) => {
  const [state, setWidgetState] = useState(widgetState.getState());
  useEffect(() => widgetState.addCallback(setWidgetState), [widgetState]);

  return (
    <DirectionsResultControlsViewMulti
      {...state}
      fullRoutePreviewEnabled={state.fullRoutePreviewEnabled === true}
      showPillHandle={!isDesktop() || state.fullRoutePreviewEnabled === true}
      isNavigating={true}
      logoUrl={logoUrl}
      clientName={clientName}
      isBackButtonDisabled={isBackButtonDisabled}
      onBackButtonClicked={onBackButtonClicked}
      onBackFromNavigationClicked={onBackFromNavigationClicked}
      onSwitchDirectionsButtonClicked={onSwitchDirectionsButtonClicked}
      onSwitchRouteTypeButtonClicked={onSwitchRouteTypeButtonClicked}
      onInputClearButtonClick={onInputClearButtonClick}
      onInputChange={handleChange}
      onInputSelect={handleInputSelect}
      searchInputs={widgetState.lastState.searchInputs}
      handleSearchInputsChange={handleSearchInputsChange}
      handleAddStopSelect={handleAddStopSelect}
      T={T}
      widgetState={widgetState}
      isMobile={!isDesktop()}
      {...rest}
    />
  );
};

export default DirectionsResultControls;
